import loadCrisp from "../utils/load_crisp_chat";
import { type UserSettings } from "@commons/types/user-settings.ts";

type userType = Pick<
  UserSettings,
  "_id" | "email" | "first_name" | "last_name" | "occupation" | "organisation"
>;

export function useSetupCrisp() {
  const setupCrisp = (user: userType) => {
    if (import.meta.env.VITE_CRISP_ID) {
      // Set the crisp session ID to the user ID
      window.CRISP_TOKEN_ID = user._id;
      // Load the Crisp chat module if it's a new session otherwise show it
      if (!window.$crisp) {
        loadCrisp();
      } else {
        // Reset the session and show the chatbox
        window.$crisp.push(["do", "session:reset"]);
        window.$crisp.push(["do", "chat:show"]);
      }
      window.$crisp.push(["set", "session:event", ["user:login"]]);
    }

    if (window.$crisp) {
      // Configure callback when sending message
      window.$crisp.push([
        "on",
        "message:sent",
        () =>
          window.$crisp.push([
            "set",
            "session:event",
            [[["last_message_url", { url: window.location.href }, "pink"]]],
          ]),
      ]);

      // Send user info to Crisp
      window.$crisp.push(["set", "user:email", user.email]);
      window.$crisp.push([
        "set",
        "user:nickname",
        `${user.first_name} ${user.last_name}`,
      ]);
      window.$crisp.push([
        "set",
        "user:company",
        [
          user.organisation,
          {
            employment: [user.occupation, user.occupation],
          },
        ],
      ]);
    }
  };

  return {
    setupCrisp,
  };
}
